// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5641":"4dfa2e3f2030ae9f","6930":"ab767cbadbf6a16b"}[chunkId] + ".css";
};